// ACTIVATE authSagas from src/redux/sagas.js
import { all, call, select, fork, put, takeLatest } from "redux-saga/effects";
import { API } from "aws-amplify";
import * as log from "loglevel";
// import { acquirePoliciesSaga } from '../iot/saga';
import { getUserPrivilegesSuccess, getUserPrivilegesError, webPushPermissionError, webPushPermissionSuccess } from "./actions";

import { APP_PUSH_TOKEN_SUCCESS, USER_PRIVILEGES_GET, WEBPUSH_PERMISSION_START } from "../actions";

import BasePaths from "../../constants/basePaths";
import WebPush from "../../libs/Webpush";
import { setAppPushToken } from "../../libs/firebaseWebpushHandler";
import { sendMessageToWebview } from "../../helpers/webview";

export const getUserPrivilegesAsync = async (appId, hotelId, api = API) => {
  const apiName = "WebeeAuthorization";
  const path = `${BasePaths.AUTHORIZATION_BASE}/privileges/${appId}/${hotelId}`;
  try {
    const result = await api.get(apiName, path, { timeout: 20 * 1000 });
    return result;
  } catch (err) {
    throw err;
  }
};
export function* getWebPushPermission({ payload }, api = API) {
  try {
    const { hotelConfig, userPrivileges } = payload;
    yield call(WebPush, hotelConfig, userPrivileges);
    // eslint-disable-next-line no-undef
    yield put(webPushPermissionSuccess());
  } catch (err) {
    log.error(err);
    yield put(webPushPermissionError(err.message));
  }
}

export function* getAppPushToken({ payload }, api = API) {
  try {
    yield call(setAppPushToken, payload);
    // eslint-disable-next-line no-undef
  } catch (err) {
    log.error(err);
  }
}

export function* getUserPrivileges({ payload }, api = API) {
  try {
    const { appId, hotelId } = payload;
    const userPrivileges = yield call(getUserPrivilegesAsync, appId, hotelId, api);

    const { hotelConfig } = yield select(state => state.settings);
    yield call(getWebPushPermission, { payload: { hotelConfig, userPrivileges } });
    // if(Object.keys(userPrivileges).length === 0 ){
    //   yield put(getUserPrivilegesError("permission error"));
    // }else{
    yield put(getUserPrivilegesSuccess(userPrivileges));
    // }

    // yield call(getWebPushPermission, { payload: { hotelConfig, userPrivileges } });
    sendMessageToWebview(userPrivileges.webPushBaseTopic);
    // yield call(acquirePoliciesSaga);
  } catch (error) {
    yield put(getUserPrivilegesError(error));
  }
}
export function* watchGetUserPrivileges() {
  yield takeLatest(USER_PRIVILEGES_GET, getUserPrivileges);
}

export function* watchGetWebPushPermission() {
  yield takeLatest(WEBPUSH_PERMISSION_START, getWebPushPermission);
}

export function* watchGetAppPushToken() {
  yield takeLatest(APP_PUSH_TOKEN_SUCCESS, getAppPushToken);
}
export default function* rootSaga() {
  yield all([fork(watchGetUserPrivileges), fork(watchGetWebPushPermission), fork(watchGetAppPushToken)]);
}
